import 'primeicons/primeicons.css'
import { PrimeReactProvider } from 'primereact/api'
import { Button } from 'primereact/button'
import { FileUpload } from 'primereact/fileupload'
import { ProgressBar } from 'primereact/progressbar'

import { Tag } from 'primereact/tag'

import { Toast } from 'primereact/toast'
import { Tooltip } from 'primereact/tooltip'
import { useRef, useState } from 'react'

//this uses primereact components to render a cool uploader. If you will use primereact somewhere else, move the provider on root page instead of here.
export default function UploadFile({ onSubmit }) {
  const toast = useRef<Toast>(null)
  const [totalSize, setTotalSize] = useState(0)
  const fileUploadRef = useRef<FileUpload>(null)

  const onTemplateSelect = (e) => {
    let _totalSize = totalSize
    const files = e.files

    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0
    })

    setTotalSize(_totalSize)
  }

  const onTemplateUpload = (e) => {
    let _totalSize = 0

    e.files.forEach((file) => {
      _totalSize += file.size || 0
    })

    setTotalSize(_totalSize)

    // Check if toast.current is defined before showing the toast
    if (toast.current) {
      toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' })
    } else {
      console.error('Toast reference is not defined')
    }
  }

  const onTemplateRemove = (file, callback) => {
    setTotalSize(totalSize - file.size)
    callback()
  }

  const onTemplateClear = () => {
    setTotalSize(0)
  }

  const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options
    const value = totalSize / 200000
    const formatedValue =
      fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B'

    return (
      <div
        className={className}
        style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}
      >
        {chooseButton}
        {uploadButton}
        {cancelButton}
        <div className="ml-auto flex items-center gap-3">
          <span>{formatedValue} / 20 MB</span>
          <ProgressBar
            value={value}
            showValue={false}
            color="text-primary-200"
            style={{ width: '10rem', height: '12px' }}
          ></ProgressBar>
        </div>
      </div>
    )
  }

  const itemTemplate = (file, props) => {
    return (
      <div className="flex flex-wrap items-center">
        <div className="flex items-center">
          <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
          <span className="ml-3 flex items-center text-left">{file.name}</span>
        </div>
        <Tag value={props.formatSize} severity="warning" className="mx-3 px-3 py-2" />
        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    )
  }

  const emptyTemplate = () => {
    return (
      <div className="flex flex-col items-center bg-gray-200 text-center">
        <i className="pi pi-image mt-3 rounded-full bg-gray-200 p-5 text-5xl text-gray-700"></i>
        {/* Desktop Text */}
        <span className="my-5 hidden text-xl text-gray-500 sm:block">
          Trascina le immagini del tuo menu in questo box
        </span>
        {/* Mobile Text */}
        <span className="my-5 block text-xl text-gray-500 sm:hidden">
          Inserisci le immagini per visualizzare l'anteprima
        </span>
      </div>
    )
  }

  const chooseOptions = {
    label: 'Seleziona',
    icon: 'pi pi-fw pi-images',
    iconOnly: false,
    className:
      'custom-choose-btn p-button-rounded p-button-outlined text-white bg-secondary hover:bg-secondary-500 dark:text-black dark:bg-primary dark:hover:bg-primary-200',
  }
  const uploadOptions = {
    label: 'Invia il tuo menu',
    icon: 'pi pi-fw pi-cloud-upload',
    iconOnly: false,
    className:
      'custom-upload-btn p-button-success p-button-rounded p-button-outlined text-white bg-secondary hover:bg-secondary-500 dark:text-black dark:bg-primary dark:hover:bg-primary-200 flex-auto',
  }
  const cancelOptions = {
    label: 'Elimina',
    icon: 'pi pi-fw pi-times',
    iconOnly: false,
    className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined invisible',
  }

  const handleSubmit = async (event) => {
    onSubmit(event)
  }

  return (
    <PrimeReactProvider>
      <div>
        <Toast ref={toast}></Toast>

        <Tooltip
          target=".custom-choose-btn"
          content="Seleziona le foto che rappresentano il menu"
          position="bottom"
        />

        <FileUpload
          ref={fileUploadRef}
          name="fileUploader"
          url="/api/upload"
          multiple
          accept="image/*"
          onUpload={onTemplateUpload}
          onSelect={onTemplateSelect}
          onError={onTemplateClear}
          onClear={onTemplateClear}
          pt={{
            buttonbar: {
              className: 'justify-around',
            },
            content: {
              className: 'bg-gray-200 -z-10',
            },
          }}
          headerTemplate={headerTemplate}
          itemTemplate={itemTemplate}
          emptyTemplate={emptyTemplate}
          chooseOptions={chooseOptions}
          uploadOptions={uploadOptions}
          cancelOptions={cancelOptions}
          customUpload
          uploadHandler={handleSubmit}
        />
      </div>
    </PrimeReactProvider>
  )
}
